import { buildPermission } from "portal/utils/auth";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { StartupChecklistDetailsPage } from "./StartupChecklistDetailsPage";
import { StartupChecklistList } from "./StartupChecklistList";
import { useRoutes } from "react-router-dom";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import React, { FunctionComponent } from "react";

const _StartupChecklists: FunctionComponent = () => {
  return useRoutes([
    { path: "/", element: <StartupChecklistList /> },
    {
      path: "/:checklistDefinitionId",
      element: <StartupChecklistDetailsPage />,
    },
  ]);
};

export const StartupChecklists = withAuthorizationRequired(
  buildPermission(
    PermissionAction.read,
    PermissionResource.autotractor_jobs,
    PermissionDomain.all
  ),
  _StartupChecklists
);
